// @flow

/**
 * Action type to set the ID of the active modal (or undefined if needs to be hidden).
 */
export const SET_AUDIO_CHANNEL = 'SET_AUDIO_CHANNEL';
export const SET_AUDIO_CHANNEL_ADDITIONAL = 'SET_AUDIO_CHANNEL_ADDITIONAL';
export const SET_DELAY_LOCAL_CHANGE = 'SET_DELAY_LOCAL_CHANGE';
export const SET_AUDIO_STEREO = 'SET_AUDIO_STEREO';
export const SET_ORGANIZATION_LIST = 'SET_ORGANIZATION_LIST';
export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const SET_WHITEBOARD_ASSETS = 'SET_WHITEBOARD_ASSETS';
export const SET_WHITEBOARD_CATEGORIES = 'SET_WHITEBOARD_CATEGORIES';
export const SET_CHORD_DATA = 'SET_CHORD_DATA';
export const SET_CHORD_IMG = 'SET_CHORD_IMG';
export const SET_RECORDING_TYPE = 'SET_RECORDING_TYPE';
export const SET_DEVICE_USER_NAME = 'SET_DEVICE_USER_NAME';
export const SET_CIRCLE_PAN_CHANGE = 'SET_CIRCLE_PAN_CHANGE';
export const SET_BUFFER_CHANGE_USER = 'SET_BUFFER_CHANGE_USER';
export const SET_IS_BUFFER_CHANGE = 'SET_IS_BUFFER_CHANGE';
export const SET_IS_DEVICE_LISTED = 'SET_IS_DEVICE_LISTED';
export const SET_IS_RECORDING_LOADER = 'SET_IS_RECORDING_LOADER';
export const SET_IS_BUFFER_HOST_READY = 'SET_IS_BUFFER_HOST_READY';
export const SET_DEVICE_CONTAINER_STATUS = 'SET_DEVICE_CONTAINER_STATUS';
export const SET_RECORDING_MODAL_COUNT = 'SET_RECORDING_MODAL_COUNT';
export const SET_RECORDING_MODAL_ACTION = 'SET_RECORDING_MODAL_ACTION';
export const SET_RECORDING_EMAIL = 'SET_RECORDING_EMAIL';

export const SET_TRANSLATE_MESSAGE = 'SET_TRANSLATE_MESSAGE';
export const SET_MUTE_SPEAKING = 'SET_MUTE_SPEAKING';
export const SET_RECORDING_TIMER = 'SET_RECORDING_TIMER';
export const SET_SCREEN_VIEW = "SET_SCREEN_VIEW";

export const SET_APP_BASE_CONFIG = "SET_APP_BASE_CONFIG";
export const SET_SHOW_RECORDING_MODAL = "SET_SHOW_RECORDING_MODAL";
export const SET_SHOW_UPLOAD_MODAL = "SET_SHOW_UPLOAD_MODAL";

export const SET_PAID_ROOM_DETAIL = "SET_PAID_ROOM_DETAIL";
export const SET_STRIPE_ACCOUNT_CREATED = "SET_STRIPE_ACCOUNT_CREATED";
export const SET_STRIPE_ACCOUNT_VERIFIED = "SET_STRIPE_ACCOUNT_VERIFIED";
export const SET_TOOLS_OBJECT = "SET_TOOLS_OBJECT";
export const SET_USERS_LIST_ARRAY = "SET_USERS_LIST_ARRAY";
export const SET_IS_MY_RECORDINGS_MODAL = "SET_IS_MY_RECORDINGS_MODAL";
export const SET_MY_RECORDINGS_DATA = "SET_MY_RECORDINGS_DATA";
export const TOGGLE_LIGHTING_MENU_VISIBILITY = "TOGGLE_LIGHTING_MENU_VISIBILITY";

export const SET_ENABLE_RECORDING_MODAL = "SET_ENABLE_RECORDING_MODAL";
export const SET_ENABLE_WEBJAM_MODAL = "SET_ENABLE_WEBJAM_MODAL";
export const SET_DISABLE_REC_ICON = "SET_DISABLE_REC_ICON";
export const SET_SHOW_CONNECT_POPUP = "SET_SHOW_CONNECT_POPUP";

export const SET_STRIPE_ACCOUNT_REQUEST = "SET_STRIPE_ACCOUNT_REQUEST";
export const SET_DUET_USER_ID = "SET_DUET_USER_ID";

export const SET_STATE_MODEL = "SET_STATE_MODEL";
export const SET_PREJOIN_SCREEN_DEVICE_INIT = "SET_PREJOIN_SCREEN_DEVICE_INIT";
export const SET_THIRD_PARTY_MOD_EVENT = "SET_THIRD_PARTY_MOD_EVENT";
export const SET_DO_HANG_UP = "SET_DO_HANG_UP";
export const SET_DEVICE_INFO_MESSAGE = "SET_DEVICE_INFO_MESSAGE";

export const SET_PREJOIN_ROOM_RT = "SET_PREJOIN_ROOM_RT";
export const SET_HOST_BUTTON_ACTION = "SET_HOST_BUTTON_ACTION";
export const SET_OUT_AUTO_MANAGE = "SET_OUT_AUTO_MANAGE";
export const SET_CUSTOM_TOUR_ACTION = "SET_CUSTOM_TOUR_ACTION";

export const SET_REG_DEVICES = "SET_REG_DEVICES";
export const SET_AVAILABLE_USER_IP = "SET_AVAILABLE_USER_IP";
export const SET_DETECT_DEVICE_TIMER = "SET_DETECT_DEVICE_TIMER";

export const SET_JOIN_WITHOUT_DEVICE = "SET_JOIN_WITHOUT_DEVICE";

export const SET_BROWSER_DEVICE_STATUS = "SET_BROWSER_DEVICE_STATUS";
export const SET_PREJOIN_SCREEN_STEP_FLAG = "SET_PREJOIN_SCREEN_STEP_FLAG";
export const SET_MEDIA_DEVICE_OVERLAY = "SET_MEDIA_DEVICE_OVERLAY";

export const SET_PREJOIN_SOCK_WAIT = "SET_PREJOIN_SOCK_WAIT";
export const SET_DEVICE_DETECTING = "SET_DEVICE_DETECTING";
export const SET_ZENDESK_STATE = "SET_ZENDESK_STATE";
export const SET_MIXER_SETTINGS = "SET_MIXER_SETTINGS";




